export const dockPreferenceKey = userId => `srm:ai-dock:${userId}`;
export function readDockPreference(userId, storage) {
  try { const value=JSON.parse((storage || localStorage).getItem(dockPreferenceKey(userId)) || '{}'); return { open:value.open === true, lastChatId:typeof value.lastChatId === 'string' || typeof value.lastChatId === 'number' ? value.lastChatId : null }; } catch { return { open:false,lastChatId:null }; }
}
export function writeDockPreference(userId, value, storage) {
  if (!userId) return;
  try { (storage || localStorage).setItem(dockPreferenceKey(userId),JSON.stringify({ open:!!value.open,lastChatId:value.lastChatId || null })); } catch { /* Convenience only; chat state is not persisted here. */ }
}

const positionKey = userId => `srm:ai-dock-position:${userId}`;
export function readDockPosition(userId,storage) {
  try { const raw=(storage || localStorage).getItem(positionKey(userId)); const value=raw == null ? 16:Number(raw); return Number.isFinite(value) && value>=16 ? value:16; } catch { return 16; }
}
export function writeDockPosition(userId,right,storage) {
  if (!userId || !Number.isFinite(right)) return;
  try { (storage || localStorage).setItem(positionKey(userId),String(Math.max(16,Math.round(right)))); } catch { /* Per-user convenience; dragging still works without storage. */ }
}
